import * as actionTypes from "../constants/actionTypes";

export interface SetSearchStringAction {
  type: typeof actionTypes.SET_SEARCH_STRING;
  payload: { text: string };
}

export interface InitSearchStringAction {
  type: typeof actionTypes.INIT_SEARCH_STRING;
  payload: { text: string };
}

export type Action = SetSearchStringAction | InitSearchStringAction;

export function setSearchString(text: string): Action {
  return {
    type: actionTypes.SET_SEARCH_STRING,
    payload: {
      text
    }
  };
}

export function initSearchString(text: string): Action {
  return {
    type: actionTypes.INIT_SEARCH_STRING,
    payload: {
      text
    }
  };
}
